import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Crosshair = ({ className = "" }) => (
  <span aria-hidden className={`pointer-events-none absolute font-mono-tech text-red-brand text-sm leading-none ${className}`}>
    +
  </span>
);

export const SectionHead = ({ eyebrow, title, desc, dark = false, testid }) => (
  <div className="max-w-3xl">
    <Reveal>
      <p className={`eyebrow ${dark ? "!text-[#e63946]" : ""}`} data-testid={testid ? `${testid}-eyebrow` : undefined}>{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2
        data-testid={testid ? `${testid}-title` : undefined}
        className={`mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight leading-[1.08] ${dark ? "text-[#f8f7f4]" : "text-ink"}`}
      >
        {title}
      </h2>
    </Reveal>
    {desc && (
      <Reveal delay={0.16}>
        <p className={`mt-4 text-sm sm:text-base leading-relaxed ${dark ? "text-[#f8f7f4]/60" : "text-[#525964]"}`}>{desc}</p>
      </Reveal>
    )}
  </div>
);
